// extracted by mini-css-extract-plugin
export default {"singleCard":"Card_singleCard__w6899","imgDiv":"Card_imgDiv__odtxD","cardFig":"Card_cardFig__GhF9d","heading":"Card_heading__RRMEO","description":"Card_description__zunxI"};